import React from "react";

/**
 * Loader globale LF23.
 *
 * Riproduce il marchio: le tre forme del logo sopra la scritta "LF23", con
 * un'animazione a onda. Il logo precedente aveva forme sopra E sotto e il
 * loader le rispecchiava entrambe; quello attuale ne ha una sola fila, quindi
 * anche il loader ne ha una sola.
 *
 * Lo stile vive in src/index.css (sezione "LOADER LF23"), che è anche dove
 * stanno i colori del marchio (--lf23-blu / --lf23-lime / --lf23-teal).
 *
 * Prima di questo componente il markup era duplicato in 74 punti su 56 pagine.
 *
 * @param {string|null} testo      didascalia sotto il marchio; `null` per ometterla.
 * @param {string}      className  classe extra sul contenitore (es. la variante
 *                                 rimpicciolita usata sopra la mappa abiti).
 */
const Lf23Loader = ({ testo = "Caricamento dati in corso...", className = "" }) => (
    <div className={`lf23-loader ${className}`.trim()}>
        <div className="lf23-loader-shapes"><span></span><span></span><span></span></div>
        <div className="lf23-loader-brand">LF23</div>
        {testo ? <p>{testo}</p> : null}
    </div>
);

export default Lf23Loader;
